export interface AnnualTreeList {
    label: string,
    children: AnnualTreeList[],
    isCheck?: boolean
}

let tree206: AnnualTreeList[] = [
    {
        label: "110|服务外包类",
        isCheck: false,
        children: [
            {
                label: "110|信息技术外包服务（ITO）",
                isCheck: true,
                children: []
            },
            {
                label: "110|120|技术性业务流程外包服务（BPO）",
                isCheck: true,
                children: []
            },
            {
                label: "110|130|技术性知识流程外包服务（KPO）",
                isCheck: true,
                children: []
            },
        ]

    },
    {
        label: "200|服务贸易类",
        isCheck: false,
        children: [
            {
                label: "210|计算机和信息服务",
                isCheck: true,
                children: []
            },
            {
                label: "220|研究开发和技术服务",
                isCheck: true,
                children: []
            },
            {
                label: "230|文化技术服务",
                isCheck: true,
                children: []
            },
            {
                label: "240|中医药医疗服务",
                isCheck: true,
                children: []
            },
        ]

    },
]

let tree208: AnnualTreeList[] = [
    {
        label: "100|集成电路生产企业",
        isCheck: false,
        children: [
            {
                label: "110|线宽小于0.8微米（含）的企业",
                isCheck: true,
                children: []
            },
            {
                label: "120|线宽小于0.25微米的企业",
                isCheck: true,
                children: []
            },
            {
                label: "130|投资额超过80亿元的企业",
                isCheck: true,
                children: []
            },
            {
                label: "140|线宽小于130纳米的企业",
                isCheck: true,
                children: []
            },
            {
                label: "150|线宽小于65纳米或投资额超过150亿元的企业",
                isCheck: true,
                children: []
            },
        ]

    },
    {
        label: "200|集成电路设计企业",
        isCheck: false,
        children: [
            {
                label: "210|新办符合条件企业",
                isCheck: true,
                children: []
            },
            {
                label: "220|符合规模条件的重点集成电路设计企业",
                isCheck: true,
                children: []
            },
            {
                label: "230|符合领域的重点集成电路设计企业",
                isCheck: true,
                children: []
            },
        ]

    },
    {
        label: "300|软件企业",
        isCheck: false,
        children: [
            {
                label: "310|一般软件企业",
                isCheck: false,
                children: [
                    {
                        label: "311|新办符合条件企业",
                        isCheck: true,
                        children: []
                    },
                    {
                        label: "312|符合规模条件的重点软件企业",
                        isCheck: true,
                        children: []
                    },
                    {
                        label: "313|符合领域条件的重点软件企业",
                        isCheck: true,
                        children: []
                    },
                    {
                        label: "314|符合出口条件的重点软件企业",
                        isCheck: true,
                        children: []
                    },
                ]
            },
            {
                label: "320|嵌入式或信息系统集成软件",
                isCheck: false,
                children: [
                    {
                        label: "321|新办符合条件企业",
                        isCheck: true,
                        children: []
                    },
                    {
                        label: "322|符合规模条件的重点软件企业",
                        isCheck: true,
                        children: []
                    },
                    {
                        label: "323|符合领域条件的重点软件企业",
                        isCheck: true,
                        children: []
                    },
                    {
                        label: "324|符合出口条件的重点软件企业",
                        isCheck: true,
                        children: []
                    },
                ]
            },
        ]

    },
    {
        label: "400|集成电路封装测试企业",
        isCheck: true,
        children: [
        ]

    },
    {
        label: "500|集成电路关键专用材料生产企业",
        isCheck: true,
        children: [
        ]

    },
    {
        label: "600|集成电路专用设备生产企业",
        isCheck: true,
        children: [

        ]
    }
]
let tree214: AnnualTreeList[] = [
    {
        label: "200|债务重组",
        isCheck: false,
        children: [
            {
                label: "210|债务人",
                isCheck: true,
                children: []
            },
            {
                label: "220|债权人",
                isCheck: true,
                children: []
            },
        ]

    },
    {
        label: "300|股权收购",
        isCheck: false,
        children: [
            {
                label: "310|收购方",
                isCheck: true,
                children: []
            },
            {
                label: "320|转让方",
                isCheck: true,
                children: []
            },
            {
                label: "330|被收购企业",
                isCheck: true,
                children: []
            },
        ]

    },
    {
        label: "400|资产收购",
        isCheck: false,
        children: [
            {
                label: "410|收购方",
                isCheck: true,
                children: []
            },
            {
                label: "420|转让方",
                isCheck: true,
                children: []
            },
            {
                label: "",
                isCheck: true,
                children: []
            },
        ]

    },
    {
        label: "500|合并",
        isCheck: false,
        children: [
            {
                label: "510|合并企业",
                isCheck: true,
                children: []
            },
            {
                label: "520|被合并企业",
                isCheck: true,
                children: []
            },
            {
                label: "530|被合并企业股东",
                isCheck: true,
                children: []
            },
        ]
    },
    {
        label: "600|分立",
        isCheck: false,
        children: [
            {
                label: "620|被分立企业",
                isCheck: true,
                children: []
            },
            {
                label: "630|被分立企业股东",
                isCheck: true,
                children: []
            },
            {
                label: "610|分立企业",
                isCheck: true,
                children: []
            },
        ]
    },
]
let tree213: AnnualTreeList[] = [
    {
        label: "100|法律形式改变",
        isCheck: false,
        children: []

    },
    {
        label: "200|债务重组",
        isCheck: false,
        children: []

    },
    {
        label: "300|股权收购",
        isCheck: false,
        children: []

    },
    {
        label: "400|资产收购",
        isCheck: false,
        children: []

    },
    {
        label: "500|合并",
        isCheck: false,
        children: []

    },
    {
        label: "600|分立",
        isCheck: false,
        children: []

    },
]
let tree107: AnnualTreeList[] = [
    {
        label: "100|企业会计准则",
        isCheck: false,
        children: [
            {
                label: "110|一般企业",
                isCheck: true,
                children: []
            },
            {
                label: "120|银行",
                isCheck: true,
                children: []
            },
            {
                label: "130|证券",
                isCheck: true,
                children: []
            },
            {
                label: "140|保险",
                isCheck: true,
                children: []
            },
            {
                label: "150|担保",
                isCheck: true,
                children: []
            },
        ]

    },
    {
        label: "200|小企业会计准则",
        isCheck: false,
        children: [
        ]

    },
    {
        label: "300|企业会计制度",
        isCheck: false,
        children: [
        ]

    },
    {
        label: "400|事业单位会计准则",
        isCheck: false,
        children: [
            {
                label: "410|事业单位会计制度",
                isCheck: true,
                children: []
            },
            {
                label: "420|科学事业单位会计制度",
                isCheck: true,
                children: []
            },
            {
                label: "430|医院会计制度",
                isCheck: true,
                children: []
            },
            {
                label: "440|高等学校会计制度",
                isCheck: true,
                children: []
            },
            {
                label: "450|中小学校会计制度",
                isCheck: true,
                children: []
            },
            {
                label: "460|彩票机构会计制度",
                isCheck: true,
                children: []
            }
        ]

    },
    {
        label: "500|民间非营利组织会计制度",
        isCheck: false,
        children: [
        ]

    },
    {
        label: "600|村集体经济组织会计制度",
        isCheck: false,
        children: [
        ]

    },
    {
        label: "700|农民专业合作社财务会计制度（试行）",
        isCheck: false,
        children: [
        ]

    },
    {
        label: "999|其他",
        isCheck: false,
        children: [
        ]

    },
]
let AnnuaEITTree = [tree107,tree206,tree208,tree213,tree214,]
export default AnnuaEITTree
